module.exports = __webpack_public_path__ + "static/image21@2x-72ed77999441b66a81e28d2f2e34d656.jpg";